<template>
  <div class="app-container" style="background: #f4f5f7;">
    <div style="background: #f4f5f7;">
      <div class="flex-align steps flex-spacebetween">
        <div class="steps-left">
          <span>{{ detail.customerName }} {{ $t('billingPage.MyDepositPage.title') }}</span>
        </div>
        <div class="steps-right">
          <!-- 跳转新增钱包页面 -->
          <el-button type="primary" @click="toPrepay">{{ $t('billingPage.MyDepositPage.Prepay') }}</el-button>
        </div>
      </div>

      <div class="flex-align max-box flex-spacebetween flex-wrap">
        <div class="max-box-left">
          <div class="flex-box">
            <div class="flex-box-item">
              <span>{{ $t('billingPage.MyDepositPage.Balance') }}</span>
              <!-- <el-tooltip style="margin: 4px;" effect="dark" :content="$t('billingPage.MyDepositPage.tips1')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip> -->
              <div class="flex-box-item-bet">
                <div :style="`color:${detail.balance<0? 'red':''}`">{{ formatPrice(detail.balance) }}</div><span>=</span>
              </div>
            </div>
            <div class="flex-box-item">
              <span>{{ $t('billingPage.MyDepositPage.Available') }}</span>
              <!-- <el-tooltip style="margin: 4px;" effect="dark" :content="$t('billingPage.MyDepositPage.tips2')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip> -->
              <div class="flex-box-item-bet">
                <div :style="`color:${detail.available<0? 'red':''}`">{{ formatPrice(detail.available) }}</div><span>+</span>
              </div>
            </div>
            <div class="flex-box-item">
              <span>{{ $t('billingPage.MyDepositPage.Credit') }}</span>
              <!-- <el-tooltip style="margin: 4px;" effect="dark" :content="$t('billingPage.MyDepositPage.tips3')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip> -->
              <div class="flex-box-item-bet">
                <div :style="`color:${detail.credit<0? 'red':''}`">{{ formatPrice(detail.credit) }}</div><span>+</span>
              </div>
            </div>
            <div class="flex-box-item">
              <span>{{ $t('billingPage.MyDepositPage.Unpaid') }}</span>
              <!-- <el-tooltip style="margin: 4px;" effect="dark" :content="$t('billingPage.MyDepositPage.tips4')" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip> -->
              <div :style="`color:${detail.unpaid<0? 'red':''}`">{{ formatPrice(detail.unpaid) }}</div>
            </div>
          </div>
        </div>
        <div class="max-box-right">
          <span>{{ $t('billingPage.MyDepositPage.SecurityBond') }}</span>
          <!-- <el-tooltip style="margin: 4px;" effect="dark" :content="$t('billingPage.MyDepositPage.tips5')" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip> -->
          <div :style="`color:${detail.securityBond<0? 'red':''}`">{{ formatPrice(detail.securityBond) }}</div>
        </div>
        <div class="max-box-tip">
          <div>{{ $t('billingPage.MyDepositPage.tip1') }}</div>
          <div>{{ $t('billingPage.MyDepositPage.tip2') }}</div>
        </div>
      </div>
    </div>
    
    <div style="background: #fff;padding: 10px 20px;border: 1px solid #ddd; border-radius: 10px;">
      <div style="padding: 10px 0px;font-size:x-large">{{$t('billingPage.BillingTransactions')}}</div>
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :before-reset-search="beforeResetSearch" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.source')" prop="source">
              <!-- <BjInput v-model="queryParams.source" :placeholder="$t('inputText')" /> -->
              <BjSelectLov v-model="queryParams.source" :option-list="sourceList" :placeholder="$t('billingPage.source')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.gmtCreate')" prop="updateTime">
              <BjDateRangePicker v-model="queryParamsTransTime" :placeholder="$t('billingPage.gmtCreate')" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <BjFrontendExport
              type="primary"
              class="main-btn"
              :label-list="labelList"
              :rows="selectedRows"
              file-name="Deposit.csv"
            />
          </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import { billApi } from "@/api";

export default {
  name: 'BusinessBillingMyDeposit',
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 6,
      selection:true,
      detail: {
        balance: '0',
        available: '0',
        credit: '0',
        unpaid: '0',
        securityBond: '0',
        clientCode: null,
        customerName: null,
      },
      // 查询参数
      queryApi: billApi.getMyDepositMyWallet,
      clientCodeList: [],
      queryParamsTransTime: [],
      queryParams: {
        clientCode: this.$route.query.clientCode || this.$store.getters.userInfo.clientCode,
        source: null,
        startTime: null,
        endTime: null,
      },
      labelList: [
        { label: this.$t('billingPage.DEPID'), prop: 'paymentId', isCheck: true, disabled: false },
        { label: this.$t('billingPage.source'), prop: 'source', isCheck: true, disabled: false },
        { label: this.$t('billingPage.DEPAmount'), prop: 'amount', isCheck: true, disabled: false },
        { label: this.$t('billingPage.Operator'), prop: 'operator', isCheck: true, disabled: false },
        { label: this.$t('billingPage.gmtCreate'), prop: 'transactionTime', isCheck: true, disabled: false, export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
        { label: this.$t('billingPage.Status'), prop: 'status', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 100 },
      ],
      sourceList: [],
    };
  },
  created() {
    this.initData();
    this.getSource();
  },
  watch: {
    queryParamsTransTime(v) {
      this.queryParams.startTime = (v || [])[0];
      this.queryParams.endTime = (v || [])[1];
    },
  },
  methods: {
    // 获取钱包交易来源
    getSource() {
      billApi.getSelectWalletSource().then(res => {
        this.sourceList = res.data;
      });
    },
    // 初始化数据
    initData() {
      billApi.getMyDepositDetail({ clientCode: this.queryParams.clientCode }).then(res => {
        this.detail.balance = res.data.balance?.toFixed(2)
        this.detail.available = res.data.available?.toFixed(2)
        this.detail.credit = res.data.credit?.toFixed(2)
        this.detail.unpaid = res.data.unpaid?.toFixed(2)
        this.detail.securityBond = res.data.securityBond?.toFixed(2)
        this.detail.clientCode = res.data.clientCode
        this.detail.customerName = res.data.customerName
      });
    },
    // 跳转钱包充值详情
    toPrepay() {
      this.$toPage('BusinessBillingDeposiInfo', { type: 'add' });
    },
    formatPrice(value) {
      const num = (Number(value) || 0).toFixed(2);
      const [integer, decimal] = num.split('.');
      return integer.replace(/(\d)(?=(\d{3})+$)/g, '$1,') + '.' + decimal;
    },
    // 列表页查看按钮
    onView(row) {
      if(row.source == 'Prepay'){ 
        this.$toPage('BusinessBillingDeposit');
      }else if(row.source == 'Credit Note'){
        this.$toPage('BusinessBillingServiceInvoices');
      }else if(row.source == 'Invoice Payment' && this.$store.getters.cusId){
        // user ==> my invoice页面
        this.$toPage('BusinessBillingServiceInvoices');
      }else if(row.source == 'Invoice Payment' && !this.$store.getters.cusId){
        // admin ==> invoice页面
        this.$toPage('BusinessBillingInvoices');
      }
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTransTime = [],
      this.queryParams = {
        clientCode: this.$route.query.clientCode || this.$store.getters.userInfo.clientCode,
        source: null,
        startTime: null,
        endTime: null,
      };
      return new Promise(resolve => {
        resolve();
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  .steps{
    width: 100%;
    padding: 20px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    margin-bottom: 10px;
    &-left{
      font-size: 22px;
      width: 80%;
      padding-left: 20px;
    }
    &-right{
      width: 80px;
    }
  }
  .max-box{
    width: 100%;
    padding: 20px 0px;
    border: 1px solid #ddd;
    border-radius: 10px;
    background: #fff;
    margin-bottom: 10px;
    &-left{
      font-size: 28px;
      width: 80%;
      padding-left: 20px;
    }
    &-right{
      // width: 20%;
      width: 215px;
      border-left: 3px solid #082dc3;
      padding-left: 15px;
      margin-top: 5px;
      span {
        font-size: 19px;
        font-weight: 400;
      }
      i {
        padding: 0 4px;
        color: #082dc3;
        font-size: 20px;
      }
      div {
        font-size: 24px;
      }
    }
    &-tip{
      width: 100%;
      font-size: 14px;
      padding-left: 20px;
      padding-top: 50px
    }
  }
  .flex-box {
    display: flex;
    width: 950px;
    &-item{
      flex: 1;
      span {
        font-size: 19px;
        font-weight: 400;
      }
      i {
        padding: 0 4px;
        color: #082dc3;
        font-size: 20px;
      }
      div {
        font-size: 24px;
      }
      &-bet{
        display: flex;
        justify-content: flex-start;
        span {
          padding: 0 55px;
        }
      }
    }
  }
</style>
